var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5920_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3934 8.71683C17.4363 6.98403 17.5913 6.53763 17.5913 6.53763C17.9323 3.13443 20.7533 0.242432 24.2253 0.242432C27.9262 0.242432 30.9237 3.26163 30.9237 6.98403C30.9237 10.7088 27.9238 13.7256 24.2253 13.7256C23.4789 13.7256 22.7612 13.6008 22.0911 13.3752C22.4726 19.8912 27.6854 23.4408 27.6854 23.4408L27.0129 23.7576C18.8504 19.2552 17.2932 12.7728 17.3934 8.71443V8.71683Z",
    fill: "#29292B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0786853 8.71683C0.121608 6.98403 0.276608 6.53763 0.276608 6.53763C0.619993 3.13443 3.44099 0.242432 6.91061 0.242432C10.6115 0.242432 13.609 3.26163 13.609 6.98403C13.609 10.7088 10.6091 13.7256 6.91061 13.7256C6.16422 13.7256 5.44645 13.6008 4.77638 13.3752C5.15792 19.8912 10.3707 23.4408 10.3707 23.4408L9.69822 23.7576C1.53807 19.2576 -0.0214685 12.7752 0.0786853 8.71683Z",
    fill: "#29292B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5920_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.5c3b2589feee69a04759f79894b96c9c.svg";
export { ForwardRef as ReactComponent };